import React from "react";
import { useNavigate } from "react-router-dom";
import { LuUserPlus, LuUserMinus, LuPlay, LuCheckCircle, LuTrash2, LuMessageCircle, LuX, LuUserCheck, LuClock, LuShieldCheck } from "react-icons/lu";

const typeIcons = {
  booking_new: LuUserPlus,
  booking_cancelled: LuUserMinus,
  ride_started: LuPlay,
  ride_completed: LuCheckCircle,
  ride_deleted: LuTrash2,
  new_message: LuMessageCircle,
  admin_new_signup: LuUserCheck,
  user_pending_approval: LuClock,
  user_approved: LuShieldCheck,
};

function timeAgo(dateStr) {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "Just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

const NotificationPanel = ({ notifications, onMarkAllRead, onMarkRead, onClose }) => {
  const navigate = useNavigate();

  const handleClick = (notification) => {
    if (!notification.isRead) {
      onMarkRead(notification._id);
    }
    if (notification.type === "admin_new_signup") {
      navigate("/admin");
    } else if (notification.relatedRide) {
      navigate(`/ride/${notification.relatedRide}`);
    }
    onClose();
  };

  return (
    <div className="sr__notification-panel">
      <div className="sr__notification-panel__header">
        <h3>Notifications</h3>
        <div className="sr__notification-panel__header-right">
          <button onClick={() => { onMarkAllRead(); onClose(); }}>Mark all read</button>
          <button className="sr__notification-panel__close" onClick={onClose} aria-label="Close">
            <LuX />
          </button>
        </div>
      </div>
      <div className="sr__notification-panel__list">
        {notifications.length === 0 ? (
          <p className="sr__notification-panel__empty">No notifications yet</p>
        ) : (
          notifications.map((n) => (
            <div
              key={n._id}
              className={`sr__notification-item ${!n.isRead ? "sr__notification-item--unread" : ""}`}
              onClick={() => handleClick(n)}
            >
              <div className="sr__notification-item__icon">
                {React.createElement(typeIcons[n.type] || LuMessageCircle)}
              </div>
              <div className="sr__notification-item__content">
                <p className="sr__notification-item__title">{n.title}</p>
                <p className="sr__notification-item__message">{n.message}</p>
                <p className="sr__notification-item__time">{timeAgo(n.createdAt)}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NotificationPanel;
